<template>
  <section id="top">
    <h1>
      How Does <span class="highlight">YOUR</span> Salary Compare To The
      <span class="highlight"> Top Football Stars</span>?
    </h1>

    <p>
      The amount of money footballers earn is often incomprehensible. To help
      contextualise just how much these global superstars are earning, we’ve
      created a calculator that allows you to see how long it takes them to earn
      your salary.<br /><br />

      Warning, the results may upset you…
    </p>
  </section>
</template>

<style lang="scss" scoped>
section {
  margin-bottom: 40px;
  padding: 0px 20px 0px 20px;
}
h1 {
   @include respond(phone-only) {
    font-size: 40px;
  }
}
.highlight {
  color: $highlight1;
}
</style>